import React from 'react';
import Popular from './Popular';
import './blogPage.css';

export default function BlogPage() {
    return (
        <div>
            <Popular/>
        </div>
    )
}